import { deepmerge } from "@fastify/deepmerge";

export const mergeDashboardSettings = deepmerge({
    mergeArray: () => (_target, source) => source,
});
